
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  data: () => ({
    title: "Créer une identité visuelle : du logo aux cartes de visite",
    description:
      "Découvrez comment ALEO peut vous aider à créer une identité visuelle cohérente pour votre PME pour renforcer votre image de marque et attirer plus de clients.",
  }),

  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.description,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.title,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.description,
        },
      ],
    };
  },
};
